import React from 'react';
const bonuses = [{
  title: "BONUS 1 — Bibliothèque Complète d'Échauffements™",
  description: "Une collection d'échauffements prêts à l'emploi pour préparer efficacement vos gymnastes avant chaque séance, selon leur âge, leur niveau et vos objectifs pédagogiques."
}, {
  title: 'BONUS 2 — Jeux Pédagogiques pour la Gymnastique™',
  description: "Des dizaines de jeux et d'activités ludiques pour développer la coordination, l'équilibre, la confiance et maintenir vos élèves motivés tout au long de l'année."
}, {
  title: 'BONUS 3 — Défis Techniques du Coach™',
  description: 'Une bibliothèque de défis techniques progressifs pour stimuler la motivation de vos gymnastes et suivre leurs progrès séance après séance.'
}, {
  title: 'BONUS 4 — Calendrier Annuel de Planification™',
  description: 'Planifiez facilement votre saison grâce à des modèles de planification annuelle, mensuelle et hebdomadaire prêts à utiliser.'
}, {
  title: 'BONUS 5 — Fiches d’Évaluation et de Suivi™',
  description: "Des fiches professionnelles, grilles d'évaluation, check-lists et outils de suivi pour accompagner efficacement la progression de chaque gymnaste."
}];
export function BonusSection() {
  return <section className="py-6 px-4 sm:px-6 bg-brand-ivory" data-id="element-24">
      <div className="text-center mb-4" data-id="element-25">
        <h2 className="text-2xl sm:text-3xl font-heading font-extrabold text-brand-navy uppercase leading-tight" data-id="element-26">
          🎁 5 BONUS PREMIUM INCLUS
        </h2>
        <p className="text-sm sm:text-base text-brand-text font-medium leading-snug mt-2" data-id="element-27">
          En plus de GYMNASTIQUE PRO™, vous recevrez 5 bonus exclusifs conçus
          pour vous faire gagner encore plus de temps, enrichir vos
          entraînements et vous aider à enseigner avec encore plus de
          professionnalisme.
        </p>
      </div>
      <div className="flex flex-col gap-2.5" data-id="element-28">
        {bonuses.map(bonus => <article key={bonus.title} className="bg-white border-2 border-brand-gold/50 p-3.5 rounded-lg text-center shadow-sm" data-id="element-29">
            <h3 className="text-sm sm:text-base font-heading font-bold text-brand-navy mb-1.5 leading-tight uppercase" data-id="element-30">
              {bonus.title}
            </h3>
            <p className="text-sm text-brand-text font-medium leading-snug" data-id="element-31">
              {bonus.description}
            </p>
          </article>)}
      </div>
    </section>;
}